/* ============================================================
   I-1 · Calculadora de la Doble Pérdida
   Convierte la renta mensual del visitante en su pérdida anual real.

   Supuestos (los mismos del bono "De Comprador a Inversionista",
   donde renta $3,000/mes ↔ propiedad de $500,000):
     · valor estimado de propiedad = renta mensual × 166.67
     · revalorización no capturada = 6 % anual del valor
     · equity no construido       = 1.7 % anual del valor (5 % down, año 1)
   Todo se muestra en pantalla — la transparencia es parte del argumento.
   ============================================================ */
(function () {
  'use strict';

  var HOME_MULTIPLIER = 166.67;
  var APPRECIATION    = 0.06;
  var EQUITY_RATE     = 0.017;

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  function init() {
    var root = document.querySelector('[data-cl-calc]');
    if (!root) return;

    var input = root.querySelector('[data-cl-calc-input]');
    if (!input) return;

    var out = {
      rent:         root.querySelector('[data-cl-calc-rent]'),
      rentYear:     root.querySelector('[data-cl-calc-rent-year]'),
      appreciation: root.querySelector('[data-cl-calc-appreciation]'),
      equity:       root.querySelector('[data-cl-calc-equity]'),
      total:        root.querySelector('[data-cl-calc-total]'),
      home:         root.querySelector('[data-cl-calc-home]')
    };

    function update() {
      var rent = parseFloat(input.value) || 0;
      var home = rent * HOME_MULTIPLIER;

      var rentYear     = rent * 12;
      var appreciation = home * APPRECIATION;
      var equity       = home * EQUITY_RATE;
      var total        = rentYear + appreciation + equity;

      if (out.rent)         out.rent.textContent         = money(rent);
      if (out.rentYear)     out.rentYear.textContent     = money(rentYear);
      if (out.appreciation) out.appreciation.textContent = money(appreciation);
      if (out.equity)       out.equity.textContent       = money(equity);
      if (out.total)        out.total.textContent        = money(total);
      if (out.home)         out.home.textContent         = money(Math.round(home / 5000) * 5000);

      // Progreso de la barra, para pintar el tramo recorrido
      var min = parseFloat(input.min) || 0;
      var max = parseFloat(input.max) || 100;
      var pct = ((rent - min) / (max - min)) * 100;
      input.style.setProperty('--cl-range-pct', pct + '%');
    }

    // Latido de invitacion: se dispara al entrar en pantalla y se corta al
    // primer movimiento. Mismo patron que el triangulo y el Filtro.
    var yaMovio = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || yaMovio) return;
          root.classList.add('is-hinting');
          io.unobserve(e.target);
          window.setTimeout(function () {
            if (!yaMovio) root.classList.remove('is-hinting');
          }, 2400 * 3 + 200);
        });
      }, { threshold: 0.35 });
      io.observe(root);
    }

    input.addEventListener('input', function () {
      yaMovio = true;
      root.classList.remove('is-hinting');
      update();
    });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
